// mutations
const mutations = {
  setLanguage(state, language) {
    state.language = language;
  },
  setHomepageBanner(state, homepagebanner) {
    state.homepageBanner = homepagebanner;
  },
  setHomeFeature(state, homefeature) {
    state.homepageFeature = homefeature;
  },
  setHomeTestimoni(state, hometestimoni) {
    state.homepageTestimoni = hometestimoni;
  },
  setHomePartner(state, homepartner) {
    state.homepagePartner = homepartner;
  },
};

export default mutations;
